__turbopack_context__.v({
  "sidebar": "index-module-scss-module__f40zCW__sidebar",
});
